import { render } from "./PainelComponent.vue?vue&type=template&id=521b477e&scoped=true"
import script from "./PainelComponent.vue?vue&type=script&lang=js"
export * from "./PainelComponent.vue?vue&type=script&lang=js"

import "./PainelComponent.vue?vue&type=style&index=0&id=521b477e&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521b477e"]])

export default __exports__